import * as types from "../types_login";
import axios from "axios/index";

const ROLE = ["Admin", "Sales", "Librarian", "User"];

// Try to load user from localStorage
const savedUser = localStorage.getItem("user");
const initialUser = savedUser
  ? JSON.parse(savedUser)
  : {
      username: null,
      accessToken: null,
      firstName: "John",
      lastName: "Smith",
      email: "john@gmail.com",
      role: "User",
      associatedPartyIds: "",
      addedPartyIds: "",
    };

const state = {
  logininfo: {
    isLoading: false,
    isError: false,
    user: initialUser,
  },
};

const getters = {
  loggedInUser: (state) => {
    // Return the logged-in user (or however your getter is defined)
    return state.logininfo.user;
  },
  [types.USG_GET_REGINFO]: (state) => {
    return state.registerInfo;
  },
};

const mutations = {
  SET_USER(state, user) {
    state.logininfo.user = user;
    localStorage.setItem("user", JSON.stringify(user));
  },
  SET_ROLE(state, role) {
    state.logininfo.user.role = role;
    localStorage.setItem("user", JSON.stringify(state.logininfo.user));
  },
  SET_SESSION(state, payload) {
    if (payload == null) {
      state.logininfo.user = {};
      localStorage.removeItem("user");
      return;
    }
    state.logininfo.user = {
      username: payload.username,
      accessToken: payload.accessToken,
      firstName: payload.firstName,
      lastName: payload.lastName,
      role: payload.role,
      associatedPartyIds: payload.associatedPartyIds,
      addedPartyIds: payload.addedPartyIds,
    };
    localStorage.setItem("user", JSON.stringify(state.logininfo.user));
  },
};

const actions = {
  [types.USG_ACTION_LOGIN]: (context, payload) => {
    // console.log({ payload });
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/signin",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          // console.log(res.data.user);
          context.state.logininfo.user = {};
          context.state.logininfo.user.username = res.data.user.username;
          context.state.logininfo.user.accessToken = res.data.accessToken;
          context.state.logininfo.user.firstName = res.data.user.firstName;
          context.state.logininfo.user.lastName = res.data.user.lastName;
          context.state.logininfo.user.role = res.data.user.role;
          context.state.logininfo.user.associatedPartyIds =
            res.data.user.associatedPartyIds;
          context.state.logininfo.user.addedPartyIds =
            res.data.user.addedPartyIds;
          localStorage.setItem(
            "user",
            JSON.stringify(context.state.logininfo.user)
          );
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Login failed (server error)."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  [types.USG_ACTION_USER_UPDATE]: (context, payload) => {
    // console.log({ payload });
    context.state.logininfo.user.firstName = payload.firstName;
    context.state.logininfo.user.lastName = payload.lastName;
    context.state.logininfo.user.associatedPartyIds =
      payload.associatedPartyIds;
    context.state.logininfo.user.addedPartyIds = payload.addedPartyIds;
    localStorage.setItem("user", JSON.stringify(context.state.logininfo.user));
  },
  [types.USG_ACTION_REGISTER]: (context, payload) => {
    payload.username = payload.email;
    payload.associatedPartyIds = payload.institution;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/signup",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Registration failed."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  [types.USG_ACTION_ACTIVATE]: (context, payload) => {
    payload.email = payload.email;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/activate",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Activation failed."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  [types.USG_ACTION_RESET]: (context, payload) => {
    payload.email = payload.email;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/reset",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Password reset failed."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  [types.USG_ACTION_RECOVER]: (context, payload) => {
    payload.email = payload.email;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/recover",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Account recovery failed."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  register: (context, payload) => {
    payload.username = payload.email;
    payload.associatedPartyIds = payload.institution;
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/signup",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Registration failed."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  signIn({ commit }, payload) {
    console.log("ACTION: signIn");
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "/auth/signin",
        data: payload,
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
        .then((res) => {
          const user = {
            username: res.data.user.username,
            accessToken: res.data.accessToken,
            firstName: res.data.user.firstName,
            lastName: res.data.user.lastName,
            role: res.data.user.role,
            associatedPartyIds: res.data.user.associatedPartyIds,
            addedPartyIds: res.data.user.addedPartyIds,
          };

          commit("SET_USER", user);
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            return reject(
              error.response.data.message || "Login failed (server error)."
            );
          }
          return reject("Unable to reach the server. Please check your connection.");
        });
    });
  },
  setSession({ commit }, payload) {
    console.log("ACTION: setSession");
    commit("SET_SESSION", payload);
  },
  setRole({ commit }, payload) {
    console.log("ACTION: setRole");
    commit("SET_ROLE", payload);
  },
  signOut({ commit }) {
    console.log("ACTION: signOut");
    commit("SET_SESSION", null);
  },
  //Action to set the user role
  [types.USG_ACTION_SET_ROLE]: (context, payload) => {
    console.log("USG_ACTION_SET_ROLE", payload);
    context.state.logininfo.user.role = payload;
    localStorage.setItem("user", JSON.stringify(context.state.logininfo.user));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js